module.exports = __webpack_public_path__ + "img/1595.d281f2e8.gif";